module.exports = __webpack_public_path__ + "img/15.384ce03d.jpg";